
// COMPONENTS
import chart_display from './chart-display/chart-display.js';

export default [
	chart_display
];